// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"modal_content-nL0_L","modal_row":"modal_row-Gt0qA","label":"label-SUoKN","switcher_wrapper":"switcher_wrapper-IXf5h"};